export default __webpack_public_path__ + "static/media/newLogoAuth.307d7db1.svg";